import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { Container, ProtocoloContainer } from './Protocolo.styles';
import { Box, Button, Divider, IconButton, InputBase, Paper, Typography, useTheme } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { toast } from 'react-toastify';
import { useParams } from 'react-router-dom';
import { getConversa, getProtocoloStream } from '../../../services/resumo';
import ReactQuill from 'react-quill';
import { LoadingBall } from './LinhaDoTempo.styles';
import SendIcon from '@mui/icons-material/Send';
import { set } from 'react-ga';

function Protocolo({ tiposResumo, close, protocoloSelecionado }) {
    const param = useParams();
    const theme = useTheme();
    const [recebendoResumoStream, setRecebendoResumoStream] = useState(false);
    const [loadingResumo, setLoadingResumo] = useState(false);
    const [textoMontado, setTextoMontado] = useState('');
    // const [textoMontado, setTextoMontado] = useState(
    //     `<div class="headerMensagem"> <div style="padding: 10px;"> <span style="font-size:14px; margin:0px 5px; font-weight: 600;">Assistente R1</span>    </div>    </div>          <div class='message assistentMessage'><article>    <meta charset="UTF-8&quot;">    <title>Análise e Recomendações sobre Abordagem de Cefaleia</title>    <h1>Análise e Recomendações sobre Abordagem de Cefaleia</h1>        <section>        <h2>ERROS NA ABORDAGEM</h2>        <p>Após revisão do atendimento conforme relatado, identifica-se que o foco principal foi direcionado ao desconforto digestivo do paciente, com perspectivas em realizar exames para rastreio de neoplasias digestivas. Não houve menção a qualquer queixa de cefaleia ou aos procedimentos específicos de triagem e abordagem recomendados para casos de cefaleia.</p>    </section>    <section>        <h2>RECOMENDAÇÕES GERAIS</h2>        <h3>Caso fosse um atendimento para Cefaleia</h3>        <ol>            <li><strong>Verificar Sinais de Alerta:</strong> Seria crucial identificar sinais de alerta em pacientes que apresentassem queixas de cefaleia, seguindo a abordagem descrita para determinar se a cefaleia é primária ou secundária.</li>            <li><strong>Exame Neurológico e de Fundo de Olho:</strong> Realizar exames neurológicos detalhados assim como exame de fundo de olho em casos suspeitos de cefaleia secundária.</li>            <li><strong>Hidratação Venosa e Analgesia:</strong> Em casos de cefaleia secundária, os tratamentos propostos abrangem hidratação, analgesia sem uso de opióides e monitoramento contínuo.</li>            <li><strong>Exames Complementares:</strong> A sugestão de exames complementares e de imagem deve ser baseada na presença de sintomas específicos ou sinais de alerta, priorizando-se a tomografia de crânio apenas quando estritamente necessário para evitar exposição desnecessária a radiação.</li>            <li><strong>Manejo da Cefaleia Primária:</strong> Nos casos identificados como cefaleia primária, abordar de acordo com o tipo específico (tensional, enxaqueca ou em salvas), usando as medicações e procedimentos recomendados sem prescrição de opióides.</li>        </ol>    </section>    <section>        <h2>CONSIDERAÇÕES FINAIS SOBRE O CASO</h2>        <p>O resumo do atendimento analisado não corresponde diretamente ao algoritmo de abordagem de cefaleia, como não menciona queixas primárias de cefaleia pelo paciente. Entretanto, é fundamental em futuros atendimentos, assegurar que qualquer menção de cefaleia por pacientes seja cuidadosamente avaliada seguindo as diretrizes específicas para garantir diagnóstico e tratamento adequados.</p>        <p>Adicionalmente, é imprescindível considerar sempre uma abordagem holística dos pacientes, avaliando todas as queixas e sintomas apresentados para um manejo completo e eficaz. Em casos de cefaleia, a tomografia de crânio e outros exames devem ser realizados com base em critérios clínicos bem fundamentados, evitando-se procedimentos desnecessários que possam trazer mais danos do que benefícios aos pacientes.</p>    </section></article></div>`,
    // );
    const [mensagemUsuario, setMensagemUsuario] = useState('');
    const onlytipoProtocolos = useMemo(() => tiposResumo.filter((i) => i.protocolo), [tiposResumo]);

    useEffect(() => {
        gerarResumo(protocoloSelecionado.value, param.id);
    }, [protocoloSelecionado]);

    const gerarResumo = useCallback(async (tipo, idAtendimento) => {
        try {
            setTextoMontado((old) => old + getHearderMessage(false));
            setRecebendoResumoStream(true);
            setLoadingResumo(true);
            getProtocoloStream(
                { idAtendimento: idAtendimento, tipo: tipo },
                (error) => {
                    setLoadingResumo(false);
                    console.error('EventSource failed:', error);
                },
                (isFinish, data) => {
                    if (isFinish) {
                        setTextoMontado((old) => old + '</div>');
                        setRecebendoResumoStream(false);
                        toast.success('Protocolo gerado com sucesso!');
                        return;
                    }

                    try {
                        setLoadingResumo(false);
                        setRecebendoResumoStream(true);
                        setTextoMontado((old) => old + data);
                    } catch (error) {
                        setRecebendoResumoStream(false);
                        console.log(`Erro ao tentar montar texto de: ${data}`);
                        console.error(error);
                    }
                },
            );
        } catch (error) {
            if (error?.response?.status == 400 && error?.response?.data) {
                toast.error(error.response.data);
            } else {
                toast.error('Erro ao gerar resumo!');
            }
            console.error(error);
        } finally {
        }
    }, []);

    const perguntaAssistent = useCallback(async (allMessages) => {
        try {
            setTextoMontado((old) => old + getHearderMessage(false));
            setRecebendoResumoStream(true);
            const mensagens = allMessages.map((m) => {
                return {
                    role: m.user ? 'user' : 'assistant',
                    content: m.message,
                };
            });

            getConversa(
                mensagens,
                (error) => {
                    console.error('EventSource failed:', error);
                },
                (isFinish, data) => {
                    if (isFinish) {
                        setTextoMontado((old) => old + '</div>');
                        setRecebendoResumoStream(false);
                        toast.success('Protocolo gerado com sucesso!');
                        return;
                    }

                    try {
                        setRecebendoResumoStream(true);
                        console.log(data);
                        setTextoMontado((old) => old + data);
                    } catch (error) {
                        setRecebendoResumoStream(false);
                        console.log(`Erro ao tentar montar texto de: ${data}`);
                        console.error(error);
                    }
                },
            );
        } catch (error) {
            if (error?.response?.status == 400 && error?.response?.data) {
                toast.error(error.response.data);
            } else {
                toast.error('Erro ao gerar resumo!');
            }
            console.error(error);
        } finally {
        }
    }, []);

    const separaMensagens = (textoMontado) => {
        const div = document.createElement('div');
        div.innerHTML = textoMontado;
        const allMessages = div.getElementsByClassName('message');
        const allMessagens = [];
        for (let i = 0; i < allMessages.length; i++) {
            if (allMessages[i].classList.contains('userMessage')) {
                allMessagens.push({ user: true, message: allMessages[i].innerText });
            } else {
                allMessagens.push({ user: false, message: allMessages[i].innerText });
            }
        }
        return allMessagens;
    };

    const getHearderMessage = function (user = false) {
        if (user)
            return `  
            <div class="headerMensagem" style="justify-content:flex-end">
                
                <div style="padding: 10px;">
                    <span style="font-size:14px; margin:0px 5px; font-weight: 600;">Você</span>
                </div>
            </div>        
            <div class='message userMessage'>    
        `;

        return `
            <div class="headerMensagem">
                
                <div style="padding: 10px;">
                    <span style="font-size:14px; margin:0px 5px; font-weight: 600;">Assistente R1</span>
                </div>
            </div>      
            <div class='message assistentMessage'>      
    `;
    };

    const userSendMessage = function (message) {
        const userMessage = `
            ${getHearderMessage(true)}
            ${message.replace(/\n/g, '<br>')}
            </div>
        `;

        setTextoMontado((old) => old + userMessage);
        setMensagemUsuario('');
        perguntaAssistent(separaMensagens(textoMontado + userMessage));
        setTimeout(() => {
            scrollbodyResumoToDown();
        }, 500);
    };

    function scrollbodyResumoToDown() {
        const article = document.getElementById('bodyResumoProtocolo');
        article.scrollTop = article.scrollHeight;
    }

    return (
        <Container id="container-protocolo">
            <span>{protocoloSelecionado.name}</span>
            <ProtocoloContainer>
                {textoMontado.length > 0 && !recebendoResumoStream && (
                    <div className="headerProtocolo">
                        <Box display={'flex'} justifyContent={'space-between'}>
                            {/* <h1>Protocolo 1</h1> */}
                            <Button
                                sx={{ fontWeight: 600 }}
                                size="small"
                                variant="outlined"
                                startIcon={<ContentCopyIcon />}
                                onClick={() => {
                                    navigator.clipboard.writeText('Texto copiado, faltando codigo');
                                    console.log('texto copiado', '');
                                    toast.success('Texto copiado com sucesso!');
                                }}
                            >
                                Copiar texto
                            </Button>

                            <Button
                                onClick={close}
                                sx={{ fontWeight: 600 }}
                                size="small"
                                variant="contained"
                                startIcon={<HighlightOffIcon />}
                            >
                                Fechar
                            </Button>
                        </Box>
                    </div>
                )}
                <div className="bodyResumo" id="bodyResumoProtocolo">
                    {!loadingResumo ? (
                        <article
                            className="article-chat"
                            id="article-chat"
                            dangerouslySetInnerHTML={{ __html: textoMontado.replace('```html', '').replace('```', '') }}
                        ></article>
                    ) : (
                        <Box
                            display={'flex'}
                            flexDirection={'column'}
                            gap={'10px'}
                            justifyContent={'center'}
                            alignItems={'center'}
                            height={'100%'}
                        >
                            <Typography color={theme.palette.primary.main} variant={'h6'} fontWeight={600}>
                                Analisando, por favor aguarde.
                            </Typography>
                            <LoadingBall color={theme.palette.primary.main}></LoadingBall>
                        </Box>
                    )}
                </div>
                {textoMontado.length > 0 && (
                    <Paper component="form" sx={{ p: '2px 4px', display: 'flex', alignItems: 'center' }}>
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Pergunte ao R1"
                            multiline
                            maxRows={4}
                            value={mensagemUsuario}
                            onChange={(e) => setMensagemUsuario(e.target.value)}
                            inputProps={{ 'aria-label': 'Pergunte ao R1' }}
                            disabled={recebendoResumoStream}
                        />
                        <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                        <IconButton
                            color="primary"
                            sx={{ p: '10px' }}
                            aria-label="directions"
                            onClick={() => {
                                userSendMessage(mensagemUsuario);
                            }}
                        >
                            <SendIcon />
                        </IconButton>
                    </Paper>
                )}
            </ProtocoloContainer>
        </Container>
    );
}

export default Protocolo;
